import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';

import { map, Observable } from 'rxjs';

import { FragmentService, MediaQueryService } from '@fcom/common/services';
import { CmsArticle } from '@fcom/core-api/interfaces';
import { ModalButtons } from '@fcom/ui-components';
import { AspectRatioString } from '@fcom/common/interfaces';

@Component({
  selector: 'fin-sustainablity-info-modal',
  templateUrl: './sustainablity-info-modal.component.html',
  styleUrls: ['./sustainablity-info-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SustainablityInfoModalComponent implements OnInit {
  private fragmentService = inject(FragmentService);
  private mediaQueryService = inject(MediaQueryService);

  @Input() modalOpen: boolean;

  @Output()
  closeModal: EventEmitter<void> = new EventEmitter();

  safArticle$: Observable<CmsArticle>;

  public readonly ModalButtons = ModalButtons;
  aspectRatio$: Observable<AspectRatioString>;

  ngOnInit(): void {
    this.safArticle$ = this.fragmentService.getFragment<CmsArticle>('fragments.safInfo.url');

    this.aspectRatio$ = this.mediaQueryService
      .isBreakpoint$('mobile')
      .pipe(map((isMobile) => (isMobile ? '4x3' : '21x9')));
  }
}
